
if (EmberENV.EXTEND_PROTOTYPES === true || EmberENV.EXTEND_PROTOTYPES.String) {
  Object.defineProperty(String.prototype, 'pluralize', { configurable: true });
  Object.defineProperty(String.prototype, 'singularize', { configurable: true });
  Object.defineProperty(Ember, 'Inflector', { configurable: true });
  Object.defineProperty(Ember.String, 'singularize', { configurable: true });
  Object.defineProperty(Ember.String, 'pluralize', { configurable: true });
}
